import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const CREATE_NEW = '__create_new__';

/** Past non-dependents dropdown or create-new. */
export default function NonDependentPicker({ past = [], onPick, onCreateNew }) {
  return (
    <div>
      <Label>Non-dependent patient</Label>
      <Select
        onValueChange={(v) => {
          if (v === CREATE_NEW) onCreateNew?.();
          else onPick?.(v);
        }}
      >
        <SelectTrigger className="mt-1 bg-white" data-testid="non-dependent-pick">
          <SelectValue placeholder={past.length ? 'Select past or create new' : 'Create new non-dependent'} />
        </SelectTrigger>
        <SelectContent>
          {past.map((p) => (
            <SelectItem key={p.id} value={p.id}>
              {p.name} · {p.relationship || 'guest'}
            </SelectItem>
          ))}
          <SelectItem value={CREATE_NEW}>+ Create new non-dependent</SelectItem>
        </SelectContent>
      </Select>
      <p className="mt-1 text-xs text-stone-500">
        Non-dependents are not family members — pick a prior guest or register a new one.
      </p>
    </div>
  );
}
